module.exports = __webpack_public_path__ + "static/media/ic_zoom_in_dark.921328b0.svg";